module.exports = __webpack_public_path__ + "img/inspiration-3.efd1964.jpg";